export const buildTrackedFormUrl = (
  publicUrl: string,
  utmSource: string
): string => {
  try {
    const url = new URL(publicUrl);
    url.searchParams.set('utm_source', utmSource);
    return url.toString();
  } catch {
    const separator = publicUrl.includes('?') ? '&' : '?';
    return `${publicUrl}${separator}utm_source=${encodeURIComponent(
      utmSource
    )}`;
  }
};

export const generateUtmTagFromSourceName = (sourceName: string): string => {
  const trimmed = sourceName.trim().toLowerCase();
  if (!trimmed) return '';
  return trimmed.replace(/\s+/g, '_');
};
